module.exports = __webpack_public_path__ + "img/soc_telegram.5d3ac1c7.svg";